import React from 'react';
import {
  Button,
  FlexGrid,
  getClassNameFactory,
  Link,
  Sizes,
  TextBoldness,
  Typography,
  VerticalSpacing,
} from '@dcl/ui';
import {
  ButtonColor,
  ButtonKind,
  IconPosition,
} from '@dcl/ui/dist/elements/Button';
import { TypographyTags } from '@dcl/ui/dist/elements/Typography';
import { LightBulbIcon } from '../../icons/LightBulbIcon';
import { InfoIcon } from '../../icons/InfoIcon';
import { LinkTypes } from '@dcl/ui/dist/elements/Link';
import { PdfIcon } from '../../icons/PdfIcon';
import {
  ARTICLE_FORMAT,
  CONTENT_BTN_TITLE,
  NO_CONTENT_RESULT,
  RELATED_CONTENT_TITLE,
} from './constants';

export const RelatedContent: React.FC = () => {
  const getClassName = getClassNameFactory(RelatedContent.displayName);

  return (
    <div className={getClassName()}>
      <VerticalSpacing>
        <div className={getClassName({ descendantName: 'ansBtn' })}>
          <div>
            <Typography
              type={Sizes.XXTRASMALL}
              tag={TypographyTags.P}
              boldness={TextBoldness.Bold}
              className={getClassName({ descendantName: 'ansTag' })}
            >
              {RELATED_CONTENT_TITLE}
            </Typography>
          </div>
          <Button
            kind={ButtonKind.BUTTON}
            color={ButtonColor.SECONDARY}
            disabled={false}
            onClick={() => {}}
            icon={<LightBulbIcon />}
            iconPosition={IconPosition.LEFT}
          >
            {CONTENT_BTN_TITLE}
          </Button>
        </div>
        <div className={getClassName({ descendantName: 'resultMsg' })}>
          <InfoIcon />
          <Typography type={Sizes.XXXTRASMALL} tag={TypographyTags.P}>
            {NO_CONTENT_RESULT}
          </Typography>
        </div>
        <div className={getClassName({ descendantName: 'inlinearticles' })}>
          <Link href="#" type={LinkTypes.INLINE}>
            KeyCite overruling risk signal
          </Link>
          <FlexGrid.Row
            className={getClassName({ descendantName: 'articleDetails' })}
          >
            <FlexGrid.Col>{ARTICLE_FORMAT}</FlexGrid.Col>
            <FlexGrid.Col
              className={getClassName({ descendantName: 'formatTitle' })}
            >
              <div className={getClassName({ descendantName: 'formatInfo' })}>
                <PdfIcon /> Video
              </div>
            </FlexGrid.Col>
            <FlexGrid.Col>2 min Read</FlexGrid.Col>
          </FlexGrid.Row>
        </div>
      </VerticalSpacing>
    </div>
  );
};

RelatedContent.displayName = 'RelatedContent';
